export const SPEECH_BUBBLE_ITERATION_AGENT_ID = 'a-AKESGaw5EGGI';
